import { createHead } from '@unhead/vue/client'
import { createApp } from 'vue'
import App from './App.vue'
import directives from './directives'
import { i18n } from './modules/i18n'
import { nprogress } from './modules/nprogress'
import { pinia } from './modules/pinia'
import { router } from './modules/router'
import './style.css'

const head = createHead()

createApp(App)
  .use(router)
  .use(i18n)
  .use(pinia)
  .use(head)
  .use(nprogress)
  .use(directives)
  .mount('#app')
